import arnas1 from "@/assets/reviews/arnas.png";
import arnas1Video from "@/assets/reviews/Arnas.mp4";
import emilija from "@/assets/reviews/emilija.png";
import emilija1Video from "@/assets/reviews/Emilija.mp4";
import edvinas1 from "@/assets/reviews/edvinas.png";
import edvinas1Video from "@/assets/reviews/Edvinas.mp4";
import indrev from "@/assets/reviews/indre_v_kosmet.png";
import indrevVideo from "@/assets/reviews/indre_v_kosmet.mp4";

export const CLIENTS_SAY_VALUES: {
  id: number;
  img_src: string;
  img_mob_src: string;
  video_src: string;
  name: string;
  description: string;
}[] = [
  {
    id: 1,
    img_src: arnas1,
    img_mob_src: arnas1,
    video_src: arnas1Video,
    name: "Arnas J.",
    description: "CEO, A Cool Agency",
  },
  {
    id: 2,
    img_src: emilija,
    img_mob_src: emilija,
    video_src: emilija1Video,
    name: "Emilija V.",
    description: "Mados stilistė",
  },
  {
    id: 3,
    img_src: edvinas1,
    img_mob_src: edvinas1,
    video_src: edvinas1Video,
    name: "Edvinas V.",
    description: "CEO, Hemes",
  },
  {
    id: 4,
    img_src: indrev,
    img_mob_src: indrev,
    video_src: indrevVideo,
    name: "Indrė V.",
    description: "Kosmetologė",
  },
];
